// src/utils/minimap/series.js
// A day's series against one opponent in the scrim log — the one key every
// game number is counted under (the Lab, its library panel and the
// dashboard's 🗺 links). Kept free of imports so the dashboard can use it
// without loading the Lab.

/** "20260530|FPL" ("FPL ", "fpl" and "FPL" are one series). */
export const seriesKey = (game) => `${String(game?.Date || "")}|${String(game?.competitor || "").trim().toUpperCase()}`;
